import { Component, OnInit, ElementRef, HostListener, ChangeDetectorRef } from '@angular/core';
import { AlertService } from '../alert/alert.service';
import { Alert, AlertType } from './alert';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false,
})
export class AlertComponent implements OnInit {
  public alerts: Alert[] = [];

  constructor(
    private alertService: AlertService,
    private eRef: ElementRef,
    private cdr: ChangeDetectorRef
  ) {}

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    const target = event.target as HTMLElement;

    // Don't clear alerts if the click was inside the alert container itself,
    // or on standard buttons/inputs/modals that shouldn't dismiss alerts.
    if (
      this.eRef.nativeElement.contains(target) ||
      target.closest('button') ||
      target.closest('.modal') ||
      target.closest('app-grid')
    ) {
      return;
    }

    this.alerts = [];
  }

  ngOnInit(): void {
    console.log('🚨 AlertComponent CREATED', this);

   this.alertService.getAlert().subscribe((alert: Alert) => {
     if (!alert) {
       this.alerts = [];
       this.cdr.detectChanges();
       return;
     }

     // 2. Use immutable array assignment instead of push()
     this.alerts = [...this.alerts, alert];

     // 3. Force change detection for async HTTP streams
     this.cdr.detectChanges();
   });
  }

  public removeAlert(alert: Alert): void {
    this.alerts = this.alerts.filter(x => x !== alert);
  }

  public cssClass(alert: Alert): string {
    if (!alert) {
      return '';
    }

    // return css class based on alert type
    switch (alert.type) {
      case AlertType.Success:
        return 'alert alert-success';
      case AlertType.Error:
        return 'alert alert-danger';
      case AlertType.Info:
        return 'alert alert-info';
      case AlertType.Warning:
        return 'alert alert-warning';
    }
  }
}
